module.exports = __webpack_public_path__ + "img/photo-51.02279214.webp";